// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ContratArticle from '@/extend/classes/ContratArticle';
import ArticleItem from '@/extend/classes/ArticleItem';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { ContratArticleTypes } from '@/generated/classes/ContratArticle';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Template des contrats
export class ArticleTemplate {
  // id article
  public articleId: number;
  // Type d'article
  public articleType: ContratArticleTypes;
  // Article
  public article: ContratArticle;
  // Identifiant des items
  public itemIds: number[];
  // Items
  public items: ArticleItem[];

  constructor() {
    this.articleId = 0;
    this.articleType = ContratArticleTypes.NONE;
    this.article = new ContratArticle();
    this.itemIds = [];
    this.items = [];
  }
}

export default class ContratTemplate  {
  // Identifiant unique
  public id: number;
  // Libellé
  public name: string;
  // Titre
  public titre: string;
  // Conventions applicables
  public conventionIds: number[];
  // Emplois applicables
  public metierIds: number[];
  // Modèle conventionnel
  public useConvention: boolean;
  // Actif
  public active: boolean;
  // Templates des articles
  public articles: ArticleTemplate[];
  // Contrat en cours d'édition
  public contratId: number;
  // Modèle source
  public sourceTemplateId: number;
  // Client
  public client: string;
  // Établissement
  public etablissementId: number;
  // Convention de prévisualisation
  public conventionId: number;
  // Métier de prévisualisation
  public metierId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.name = '';
    this.titre = '';
    this.conventionIds = [];
    this.metierIds = [];
    this.useConvention = false;
    this.active = false;
    this.articles = [];
    this.contratId = 0;
    this.sourceTemplateId = 0;
    this.client = '';
    this.etablissementId = 0;
    this.conventionId = 0;
    this.metierId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ContratTemplate): ContratTemplate {
    const newContratTemplate: ContratTemplate = new ContratTemplate();
    newContratTemplate.id = obj.id;
    newContratTemplate.name = obj.name;
    newContratTemplate.titre = obj.titre;
    newContratTemplate.conventionIds = JSON.parse(JSON.stringify(obj.conventionIds));
    newContratTemplate.metierIds = JSON.parse(JSON.stringify(obj.metierIds));
    newContratTemplate.useConvention = obj.useConvention;
    newContratTemplate.active = obj.active;
    newContratTemplate.articles = JSON.parse(JSON.stringify(obj.articles));
    newContratTemplate.contratId = obj.contratId;
    newContratTemplate.sourceTemplateId = obj.sourceTemplateId;
    newContratTemplate.client = obj.client;
    newContratTemplate.etablissementId = obj.etablissementId;
    newContratTemplate.conventionId = obj.conventionId;
    newContratTemplate.metierId = obj.metierId;
    newContratTemplate.createId = obj.createId;
    newContratTemplate.failed = obj.failed;
    newContratTemplate.canUpdate = obj.canUpdate;
    newContratTemplate.canDelete = obj.canDelete;
    newContratTemplate.display = obj.display;
    newContratTemplate.clientId = obj.clientId;
    newContratTemplate.notifDefType = obj.notifDefType;
    return newContratTemplate;
  }

  public toJsonContratTemplate (): string {
    const json = {
      name: this.name,
      titre: this.titre,
      conventionIds: this.conventionIds,
      metierIds: this.metierIds,
      useConvention: this.useConvention,
      active: this.active,
      articles: this.articles,
      contratId: this.contratId,
      sourceTemplateId: this.sourceTemplateId,
      client: this.client,
      etablissementId: this.etablissementId,
      conventionId: this.conventionId,
      metierId: this.metierId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromContratTemplate (obj: ContratTemplate): void {
    this.id = obj.id;
    this.name = obj.name;
    this.titre = obj.titre;
    this.conventionIds = obj.conventionIds;
    this.metierIds = obj.metierIds;
    this.useConvention = obj.useConvention;
    this.active = obj.active;
    this.articles = obj.articles;
    this.contratId = obj.contratId;
    this.sourceTemplateId = obj.sourceTemplateId;
    this.client = obj.client;
    this.etablissementId = obj.etablissementId;
    this.conventionId = obj.conventionId;
    this.metierId = obj.metierId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareContratTemplate (value: ContratTemplate): boolean {
    return (this.toJsonContratTemplate() == value.toJsonContratTemplate());
  }

  public cloneContratTemplate (): ContratTemplate {
    return ContratTemplate.fromJson(this);
  }

  public createForStoreContratTemplate (): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrattemplates/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContratTemplate(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreContratTemplate (): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/contrattemplates/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContratTemplate(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreContratTemplate (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/contrattemplates/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrattemplates/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static load (id: number): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/contrattemplates/load/' + id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ContratTemplate.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getList (): Promise<ContratTemplate[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/contrattemplates/getList', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: ContratTemplate[] = [];
              res.data.forEach(( a: ContratTemplate ) => {
                cData.push(ContratTemplate.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static preview (contratTemplate: ContratTemplate): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrattemplates/preview', contratTemplate, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ContratTemplate.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static save (contratTemplate: ContratTemplate): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrattemplates/save', contratTemplate, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ContratTemplate.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ContratTemplates/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = ContratTemplate.fromJson(listData.reccords[0] as ContratTemplate);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ContratTemplates/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = ContratTemplate.fromJson(listData.reccords[0] as ContratTemplate);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(contratTemplates: ContratTemplate[]) {
  }
}
